import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import classes from "./breadcrumb.module.scss";

const Breadcrumbs = (props) => {
  useEffect(() => {
    const breadCrumbSchema = {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "HOME",
          item: "https://sunnydiamonds.com",
        },
        props.ancestor === "jewellery" || props.ancestor === "Jewellery"
          ? {
            "@type": "ListItem",
            position: 2,
            name: props.ancestor,
            item: `https://sunnydiamonds.com/jewellery/${props.ancestor}`,
          }
          : null,
        {
          "@type": "ListItem",
          position: 2,
          name: "JEWELLERY",
          item: "https://sunnydiamonds.com/jewellery",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: props.current,
          item: `https://sunnydiamonds.com/jewellery/${props.current ? props.current : props.ancestor
            }`,
        },
      ],
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(breadCrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <ul className={`${classes.breadcrumbs} d-flex breadcrumbs`}>
      <li className={classes.bread_crumb_item}>
        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
      </li>
      {props.ancestor && (
        <li className={` ${classes.bread_crumb_item} ${!props.current ? classes.active : ""}`}>
          {props.ancestor === "jewellery" || props.ancestor === "Jewellery" ? (
            <Link to={`${process.env.PUBLIC_URL}/jewellery`}>
              {props.ancestor}
            </Link>
          ) : props.ancestorLink ? (
            <Link to={`${process.env.PUBLIC_URL}${props.ancestorLink}`}>
              {props.ancestor}
            </Link>
          ) : (
            <span>{props.ancestor}</span>
          )}
        </li>
      )}
      {props.current && (
        <li className={`${classes.bread_crumb_item} ${classes.active}`}>
          <span>{props.current}</span>
        </li>
      )}
    </ul>
  );
};

export default Breadcrumbs;
